<template>
  <el-dropdown
    v-bind="$attrs"
    trigger="click"
    class="theme"
    @command="handleSetTheme"
  >
    <div>
      <el-tooltip :content="$t('msg.navBar.themeChange')">
        <svg-icon id="guide-theme" icon="change-theme" />
      </el-tooltip>
    </div>
    <template #dropdown>
      <el-dropdown-menu>
        <el-dropdown-item command="color">
          {{ $t('msg.theme.themeColorChange') }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
  <!-- 展示弹出层 -->
  <ColorSelector v-model="visible"></ColorSelector>
  <div></div>
</template>

<script setup>
import ColorSelector from './components/ColorSelector'
import { ref } from 'vue'
const visible = ref(false)
// import { useI18n } from 'vue-i18n'
// const { t } = useI18n()
const handleSetTheme = () => {
  visible.value = true
}
</script>
